export default __webpack_public_path__ + "static/media/stevejobs.ac43c439.jpg";